import { withFormik } from 'formik'
import { compose, lifecycle, withHandlers } from 'recompose'

import { required, validEmail, validFullName } from 'utils/validation'
import {FORM_ACTION_ERROR_STATUS, FORM_PROGRESS_STATUS, FORM_SUBMIT_STATUS} from 'constants/form'

export default compose(
  withFormik({
    mapPropsToValues: ({ initialValues }) => ({ ...initialValues }),
    validate: ({ name, email }) => {
      const errors = {}

      if (required(name)) {
        errors.name = 'Please enter your name'
      } else if (validFullName(name)) {
        errors.name = 'You must enter a first and a last name'
      }

      if (required(email)) {
        errors.email = 'Please enter your email address'
      } else if (!validEmail(email)) {
        errors.email = 'Please enter a valid email address'
      }

      return errors
    },
    enableReinitialize: true,
    validateOnChange: false,
    handleSubmit: (values, {
      props, setSubmitting,
    }) => {
      setSubmitting(true)

      if (props.onFormSubmit) {
        props.onFormSubmit(values)
      }
    },
  }),
  withHandlers({
    handleFieldChange: props => (event) => {
      props.setStatus(FORM_PROGRESS_STATUS)
      props.handleChange(event)
    },
    handleFormSubmit: props => (event) => {
      props.setStatus(FORM_SUBMIT_STATUS)
      props.handleSubmit(event)
    },
    hasFieldError: props => (fieldName) => {
      return !!((props.errors[fieldName] && props.errors[fieldName].length && props.status === FORM_SUBMIT_STATUS))
    },
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        apiCallError, setStatus, setSubmitting
      } = this.props
      
      if (prevProps.apiCallError !== apiCallError && apiCallError) {
        setStatus(FORM_ACTION_ERROR_STATUS)
        setSubmitting(false)
      }
    },

  })
)




// WEBPACK FOOTER //
// ./src/components/organisms/EditDetailsForm/EditDetailsForm.enhancer.js